export default {"src":"/_next/static/media/logout.b0633833.svg","height":683,"width":683,"blurWidth":0,"blurHeight":0};